module.exports = __webpack_public_path__ + "img/vegetable-snap-peas-190x100.6f896010.jpg";